import type {
  TireQuoteAdminNoteAttachmentDeleteApiData,
  TireQuoteAdminNoteAttachmentDeleteApiResponses,
  TireQuoteAdminNoteAttachmentsBulkCreateApiData,
  TireQuoteAdminNoteAttachmentsBulkCreateApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';
import { noteAttachmentFilesFormData } from '../noteAttachmentFormData';

export const tireQuoteAdminNoteAttachmentUrls = {
  postTireOfferAdminNoteAttachmentsBulk: responseEndpoint<
    TireQuoteAdminNoteAttachmentsBulkCreateApiData,
    TireQuoteAdminNoteAttachmentsBulkCreateApiResponses
  >({
    getUrl: ({ tireQuoteAdminNoteId }) =>
      apiUrl(`car-tire-quote-admin-notes/${tireQuoteAdminNoteId}/attachments/bulk/`),
    getHeaders: () => ({ 'Content-Type': 'multipart/form-data' }),
    getBody: ({ files }) => noteAttachmentFilesFormData(files),
    skipBodyTransformation: true
  }),
  deleteTireOfferAdminNoteAttachment: dataEndpoint<
    TireQuoteAdminNoteAttachmentDeleteApiData,
    TireQuoteAdminNoteAttachmentDeleteApiResponses
  >({
    getUrl: ({ tireQuoteAdminNoteId, attachmentId }) =>
      apiUrl(`car-tire-quote-admin-notes/${tireQuoteAdminNoteId}/attachments/${attachmentId}/`)
  })
};
